import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import "./ArchiveNotice.less"

const { Title, Paragraph } = WebsiteTypography

const ArchiveNotice: FC = () => {
  const { xxl, xl, lg, md } = useBreakpoint()
  const isMobileScr = !(xxl || xl || lg || md)

  const { setIsModalDarkOpen } = useModalDarkContext()

  return (
    <Row justify={"center"} className={"archive-notice-wrapper"} style={{ paddingBottom: 24 }}>
      <Col span={18} xxl={18} xl={18} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"}>
          <div className={"archive-notice-hex-wrapper"}>
            <SvgIcon type={"archive"} />
          </div>
        </Row>

        <Title
          level={isMobileScr ? 5 : 3}
          centered
          className={"section-title"}
          style={{ paddingTop: 12, paddingBottom: 16 }}
        >
          <span className={"bold"}>{"Automatic "}</span>
          <span className={"w300"}>{"Project Archiving"}</span>
        </Title>

        <Row justify={"center"} style={{ paddingTop: 4 }}>
          <Col span={24}>
            <Paragraph
              centered
              size={isMobileScr ? "sm" : "md"}
              color={"website-secondary"}
              weight={"w300"}
              style={{ paddingBottom: 24 }}
            >
              {"Project archiving is now handled automatically. Projects older than 5 years will be moved to the "}
              <span className={"bold"}>{"Archived"}</span>
              {" section, where they will remain accessible."}
            </Paragraph>
            <Paragraph size={isMobileScr ? "xs" : "sm"} color={"website-secondary"} weight={"w300"} centered>
              {
                "This helps keep the main project list organized and focused on current projects while preserving access to older ones whenever needed."
              }
            </Paragraph>
          </Col>
        </Row>

        <DividerWithHex />
      </Col>

      <Col span={isMobileScr ? 24 : 10}>
        <Row justify={"center"} style={{ paddingTop: 8, width: "100%" }}>
          <Col span={24}>
            <Button btnType={"primary"} text={"Close"} onClick={() => setIsModalDarkOpen(false)} block size={"large"} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ArchiveNotice
